import { Controller } from '@hotwired/stimulus';

export default class PepMandateController extends Controller {
  static targets = ['typeSelect', 'typeOther'];

  connect() {
    if (!this.typeSelectTarget.disabled) {
      this.#applyMutex();
    }
  }

  syncState() {
    this.#applyMutex();
  }

  updateFromSelect() {
    if (this.typeSelectTarget.value) {
      this.typeOtherTarget.value = '';
      this.typeOtherTarget.disabled = true;
    } else {
      this.typeOtherTarget.disabled = false;
    }
  }

  updateFromOther() {
    if (this.typeOtherTarget.value.trim()) {
      this.typeSelectTarget.value = '';
      this.typeSelectTarget.disabled = true;
    } else {
      this.typeSelectTarget.disabled = false;
    }
  }

  #applyMutex() {
    if (this.typeSelectTarget.value) {
      this.typeOtherTarget.value = '';
      this.typeOtherTarget.disabled = true;
    } else if (this.typeOtherTarget.value) {
      this.typeSelectTarget.value = '';
      this.typeSelectTarget.disabled = true;
    }
  }
}
